import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface GDPRConsentProps {
  gdprConsent: boolean;
  marketingConsent: boolean;
  retentionPeriod: string;
  onGDPRConsentChange: (value: boolean) => void;
  onMarketingConsentChange: (value: boolean) => void;
  onRetentionPeriodChange: (value: string) => void;
}

export const GDPRConsent = ({
  gdprConsent,
  marketingConsent,
  retentionPeriod,
  onGDPRConsentChange,
  onMarketingConsentChange,
  onRetentionPeriodChange,
}: GDPRConsentProps) => {
  return (
    <div className="space-y-4 p-4 border rounded-lg">
      <h3 className="font-medium">Data Protection & Privacy</h3>
      
      <div className="flex items-center justify-between">
        <Label htmlFor="gdpr-consent">
          I consent to my data being processed according to the privacy policy
        </Label>
        <Switch
          id="gdpr-consent"
          checked={gdprConsent}
          onCheckedChange={onGDPRConsentChange}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label htmlFor="marketing-consent">
          I agree to receive marketing communications
        </Label>
        <Switch
          id="marketing-consent"
          checked={marketingConsent}
          onCheckedChange={onMarketingConsentChange}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="retention-period">Data Retention Period</Label>
        <Select
          value={retentionPeriod}
          onValueChange={onRetentionPeriodChange}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select retention period" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1 year">1 Year</SelectItem>
            <SelectItem value="2 years">2 Years</SelectItem>
            <SelectItem value="3 years">3 Years</SelectItem>
            <SelectItem value="5 years">5 Years</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};